import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { PlateDesktop as Plate } from '@alfa-bank/site-plate/desktop';
import { TextDesktop } from '@alfa-bank/site-text-v2/desktop';

import { OfficeSelectionDesktop as OfficeSelection } from '../components/office-selection/desktop';
import { OfficeDelivery as Component } from '../office-delivery';
import type { TOfficesDelivery, IDeps } from '../models';

export const OfficeDeliveryDesktop = createWidget<IDeps, TOfficesDelivery>({
    OfficeSelection,
    Text: TextDesktop,
    Plate,
})(Component);
